"use strict";exports.arrayFrom=function(r){return Array.prototype.slice.call(r)};
//# sourceMappingURL=arrayFrom.cjs.map
